/**
 * Copyright 2019 CANAL+ Group
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ContentType } from "./types";
var ContentManager = /** @class */ (function () {
    function ContentManager(manifest, quality) {
        if (quality === void 0) { quality = "MEDIUM"; }
        this.manifest = manifest;
        this.quality = quality;
    }
    ContentManager.prototype.getContextsForCurrentSession = function () {
        var _this = this;
        return this.manifest.periods.reduce(function (acc, period) {
            var videoContexts = _this.decideUniqContext(period.getAdaptationsForType(ContentType.VIDEO), ContentType.VIDEO);
            acc.video.push({ period: period, contexts: videoContexts });
            var audioContexts = _this.decideUniqContext(period.getAdaptationsForType(ContentType.AUDIO), ContentType.AUDIO);
            acc.audio.push({ period: period, contexts: audioContexts });
            var textContexts = _this.decideUniqContext(period.getAdaptationsForType(ContentType.TEXT), ContentType.TEXT);
            acc.text.push({ period: period, contexts: textContexts });
            return acc;
        }, { video: [], audio: [], text: [], manifest: this.manifest });
    };
    ContentManager.prototype.getContextsFormatted = function (globalCtx) {
        var video = globalCtx.video.reduce(function (_, currVideo) {
            return currVideo.contexts.map(function (videoContext) { return (__assign({ manifest: globalCtx.manifest, period: currVideo.period }, videoContext)); });
        }, []);
        var audio = globalCtx.audio.reduce(function (_, currAudio) {
            return currAudio.contexts.map(function (audioContext) { return (__assign({ manifest: globalCtx.manifest, period: currAudio.period }, audioContext)); });
        }, []);
        var text = globalCtx.text.reduce(function (_, currText) {
            return currText.contexts.map(function (textContext) { return (__assign({ manifest: globalCtx.manifest, period: currText.period }, textContext)); });
        }, []);
        return { video: video, audio: audio, text: text };
    };
    ContentManager.prototype.getRepresentationByQualityBitrate = function (representations) {
        switch (this.quality) {
            case "HIGH":
                return representations.reduce(function (acc, curr) {
                    if (curr.bitrate > acc.bitrate) {
                        return curr;
                    }
                    return acc;
                });
            case "MEDIUM":
                return representations[Math.floor(representations.length / 2)];
            case "LOW":
                return representations.reduce(function (acc, curr) {
                    if (curr.bitrate < acc.bitrate) {
                        return curr;
                    }
                    return acc;
                });
            default:
                return representations[Math.floor(representations.length / 2)];
        }
    };
    ContentManager.prototype.decideRepresentation = function (representations, contentType) {
        switch (contentType) {
            // If we want to take a representation by bufferType
            // case ContentType.VIDEO: {
            //   return this.getRepresentationByQualityBitrate(representations);
            // }
            // case ContentType.AUDIO: {
            //   return this.getRepresentationByQualityBitrate(representations);
            // }
            // case ContentType.TEXT: {
            //   return this.getRepresentationByQualityBitrate(representations);
            // }
            default:
                return this.getRepresentationByQualityBitrate(representations);
        }
    };
    ContentManager.prototype.decideUniqContext = function (adaptations, contentType) {
        var _this = this;
        return adaptations.reduce(function (acc, adaptation) {
            var representation = _this.decideRepresentation(adaptation.representations, contentType);
            var segment = representation.index.getInitSegment();
            if (segment === null) {
                throw new Error("Error while constructing the init segment");
            }
            acc.push({
                adaptation: adaptation,
                representation: representation,
                segment: segment,
            });
            return acc;
        }, []);
    };
    return ContentManager;
}());
export default ContentManager;
